import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './BlogIndex.css';
import blogPosts from '../data/blogPosts';
import usePageMeta from '../hooks/usePageMeta';
import Footer from './Footer';
import BookCallModal from './BookCallModal';

const BlogIndex = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  usePageMeta({
    title: 'Blog | Second Life Software — Guides for Non-Technical Founders',
    description:
      'Practical, jargon-free guides for founders building software: what an MVP costs, who to hire to build your app, and how the build process really works.',
    path: '/blog',
  });

  return (
    <div className="blog-page">
      <header className="blog-topbar">
        <Link to="/" className="blog-logo">Second Life Software</Link>
        <button className="blog-topbar-btn" onClick={() => setIsModalOpen(true)}>
          Book a Call
        </button>
      </header>

      <section className="blog-index">
        <div className="blog-index-container">
          <div className="blog-index-header">
            <span className="blog-index-eyebrow">The Blog</span>
            <h1 className="blog-index-title">Guides for founders building software</h1>
            <p className="blog-index-subtitle">
              Straight-talk advice on turning an idea into a real product — costs, hiring,
              and what the build process actually looks like. No jargon.
            </p>
          </div>

          <div className="blog-index-grid">
            {blogPosts.map((post) => (
              <Link key={post.slug} to={`/blog/${post.slug}`} className="blog-index-card">
                {post.tag && <span className="blog-index-tag">{post.tag}</span>}
                <h2 className="blog-index-card-title">{post.title}</h2>
                <p className="blog-index-card-excerpt">{post.excerpt}</p>
                <div className="blog-index-card-meta">
                  <span>{post.date}</span>
                  <span>{post.readTime}</span>
                </div>
                <span className="blog-index-readmore">Read article →</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />
      <BookCallModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
};

export default BlogIndex;
